import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { Row, Col } from 'src/componentes/grid';
import qs from 'query-string';
import useAuth from 'src/hooks/useAuth';
import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';
import LoadingContainer from 'src/componentes/loading-container';
import Button from 'src/componentes/button';
import FiltroChip from 'src/componentes/filtro-chip';
import FiltroDrawerNew from 'src/componentes/filtro/FiltroDrawerNew';
import InfoPanel from 'src/componentes/info-panel';
import Grafico from 'src/paginas/item/valor/componentes/grafico';
import { capitalizeFirstLetter } from 'src/utils/string';

const GraficosAcoes = ({ ...rest }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [isDrawerMounted, setIsDrawerMounted] = useState(false);
  const [showFilterDrawer, setShowFilterDrawer] = useState(false);
  const [showBannerChartResponsavel, setShowBannerChartResponsavel] =
    useState(true);
  const [showBannerChartTag, setShowBannerChartTag] = useState(true);
  const [showBannerChartArea, setShowBannerChartArea] = useState(true);
  const [showBannerChartItens, setShowBannerChartItens] = useState(true);
  const [chartQuantidadeAcoesPorFarol, setChartQuantidadeAcoesPorFarol] =
    useState(null);
  const [chartQuantidadeAcoesPorStatus, setChartQuantidadeAcoesPorStatus] =
    useState(null);
  const [
    chartQuantidadeAcoesPorResponsavel,
    setChartQuantidadeAcoesPorResponsavel,
  ] = useState(null);
  const [chartQuantidadeAcoesPorTag, setChartQuantidadeAcoesPorTag] =
    useState(null);
  const [chartQuantidadeAcoesPorArea, setChartQuantidadeAcoesPorArea] =
    useState(null);
  const [chartQuantidadeAcoesPorItens, setChartQuantidadeAcoesPorItens] =
    useState(null);
  const { filtroId, showSearch, searchComponent, searchSchema, url } = rest;

  const openLastFilter = async () => {
    try {
      const endpoint = `/FiltroColaborador/${filtroId}/AbrirUltimoFiltro`;
      const filtroFavoritoId = window.location.search
        ? qs.parse(window.location.search, { ignoreQueryPrefix: true })
            .filtroFavoritoId || null
        : null;
      const response = await http.post(endpoint, {
        filtroFavoritoId: filtroFavoritoId,
      });
      setSelectedFilter(response.data);
    } catch (err) {
      errorHandler(err);
    }
  };

  useEffect(() => {
    const loadInitialFilter = async () => {
      setIsLoading(true);
      await openLastFilter();
    };

    loadInitialFilter();
  }, []);

  const obterGraficos = async () => {
    try {
      const endpoint = '/Acao/ObterGraficosAcoes';
      const response = await http.post(endpoint, {
        searchModel: selectedFilter?.valor,
        parameters: {},
      });
      const graficosArray = Object.entries(response.data).map(
        ([key, value]) => ({
          chave: key,
          ...value,
        })
      );
      const graficoQuantidadeAcoesPorFarol = graficosArray.find(
        (item) => item.chave === 'QuantidadeAcoesPorFarol'
      );
      const graficoQuantidadeAcoesPorStatus = graficosArray.find(
        (item) => item.chave === 'QuantidadeAcoesPorStatus'
      );
      const graficoQuantidadeAcoesPorResponsavel = graficosArray.find(
        (item) => item.chave === 'QuantidadeAcoesPorResponsavel'
      );
      const graficoQuantidadeAcoesPorTag = graficosArray.find(
        (item) => item.chave === 'QuantidadeAcoesPorTag'
      );
      const graficoQuantidadeAcoesPorArea = graficosArray.find(
        (item) => item.chave === 'QuantidadeAcoesPorArea'
      );
      const graficoQuantidadeAcoesPorItens = graficosArray.find(
        (item) => item.chave === 'QuantidadeAcoesPorItens'
      );

      setChartQuantidadeAcoesPorFarol(graficoQuantidadeAcoesPorFarol);
      setChartQuantidadeAcoesPorStatus(graficoQuantidadeAcoesPorStatus);
      setChartQuantidadeAcoesPorResponsavel(
        graficoQuantidadeAcoesPorResponsavel
      );
      setChartQuantidadeAcoesPorTag(graficoQuantidadeAcoesPorTag);
      setChartQuantidadeAcoesPorArea(graficoQuantidadeAcoesPorArea);
      setChartQuantidadeAcoesPorItens(graficoQuantidadeAcoesPorItens);
    } catch (err) {
      errorHandler(err);
    }
  };

  useEffect(() => {
    if (!selectedFilter) return;

    const loadCharts = async () => {
      setIsLoading(true);
      await obterGraficos();
      setIsLoading(false);
    };

    loadCharts();
  }, [selectedFilter]);

  const refresh = async () => {
    setIsLoading(true);

    await openLastFilter();
  };

  const handleOpenDrawer = () => {
    setIsDrawerMounted(true);
    setTimeout(() => {
      setShowFilterDrawer(true);
    }, 10);
  };

  const handleCloseDrawer = () => {
    setShowFilterDrawer(false);

    setTimeout(() => {
      setIsDrawerMounted(false);
    }, 300);
  };

  const handleCloseBannerChartArea = () => {
    setShowBannerChartArea(false);
  };

  const handleCloseBannerChartTag = () => {
    setShowBannerChartTag(false);
  };

  const handleCloseBannerChartResponsavel = () => {
    setShowBannerChartResponsavel(false);
  };

  const handleCloseBannerChartItens = () => {
    setShowBannerChartItens(false);
  };

  return (
    <LoadingContainer isLoading={isLoading}>
      <Card>
        <CardHeader>
          <div className="align-items-center d-flex justify-content-between">
            <div />
            {(selectedFilter && selectedFilter.valor) || selectedFilter ? (
              <div style={{ minWidth: 40 }} className="mr-auto">
                <FiltroChip
                  {...rest}
                  updateProps={true}
                  filtroId={filtroId}
                  onSearch={refresh}
                  selectedFilter={
                    selectedFilter && selectedFilter.valor != null
                      ? selectedFilter.valor
                      : selectedFilter
                  }
                  currentFilter={selectedFilter}
                />
              </div>
            ) : (
              <div />
            )}
            <div className="d-inline-flex">
              {showSearch && searchComponent && (
                <Button
                  className="tw:ms-4"
                  toolbar
                  icon="Filter"
                  onClick={handleOpenDrawer}
                />
              )}
            </div>
          </div>
        </CardHeader>
        <CardBody style={{ backgroundColor: '#f6f9fc' }}>
          <Row className="mb-3">
            <Col md={12} className="px-2">
              <div
                style={{
                  backgroundColor: 'white',
                  padding: '12px',
                }}
              >
                {chartQuantidadeAcoesPorItens && (
                  <>
                    <div className="font-weight-bolder">
                      {capitalizeFirstLetter(resources.item)}
                    </div>
                    {showBannerChartItens && (
                      <InfoPanel onDismiss={handleCloseBannerChartItens}>
                        {intl.formatMessage(
                          {
                            id: 'top10ItensPorAcoes',
                          },
                          { acoes: resources.acoes }
                        )}
                      </InfoPanel>
                    )}
                    <Grafico
                      height={320}
                      grafico={chartQuantidadeAcoesPorItens}
                      exibirTitulos={false}
                    />
                  </>
                )}
              </div>
            </Col>
          </Row>
          <Row className="mb-3">
            {chartQuantidadeAcoesPorFarol && (
              <Col md={6} className="px-2">
                <div
                  style={{
                    backgroundColor: 'white',
                    padding: '12px',
                  }}
                >
                  <>
                    <div className="font-weight-bolder">
                      {intl.formatMessage({ id: 'label.farol' })}
                    </div>
                    <Grafico
                      height={320}
                      grafico={chartQuantidadeAcoesPorFarol}
                      exibirTitulos={false}
                    />
                  </>
                </div>
              </Col>
            )}
            <Col md={6} className="px-2">
              <div
                style={{
                  backgroundColor: 'white',
                  padding: '12px',
                }}
              >
                {chartQuantidadeAcoesPorStatus && (
                  <>
                    <div className="font-weight-bolder">
                      {intl.formatMessage({
                        id: 'status',
                      })}
                    </div>
                    <Grafico
                      height={320}
                      grafico={chartQuantidadeAcoesPorStatus}
                      exibirTitulos={false}
                    />
                  </>
                )}
              </div>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={12} className="px-2">
              <div
                style={{
                  backgroundColor: 'white',
                  padding: '12px',
                }}
              >
                {chartQuantidadeAcoesPorResponsavel && (
                  <>
                    <div className="font-weight-bolder">
                      {capitalizeFirstLetter(resources.responsavel)}
                    </div>
                    {showBannerChartResponsavel && (
                      <InfoPanel onDismiss={handleCloseBannerChartResponsavel}>
                        {intl.formatMessage(
                          {
                            id: 'top10ResponsaveisPorAcoes',
                          },
                          {
                            responsaveis: resources.responsaveis,
                            acoes: resources.acoes,
                          }
                        )}
                      </InfoPanel>
                    )}
                    <Grafico
                      height={320}
                      grafico={chartQuantidadeAcoesPorResponsavel}
                      exibirTitulos={false}
                    />
                  </>
                )}
              </div>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6} className="px-2">
              <div
                style={{
                  backgroundColor: 'white',
                  padding: '12px',
                }}
              >
                {chartQuantidadeAcoesPorTag && (
                  <>
                    <div className="font-weight-bolder">
                      {capitalizeFirstLetter(
                        intl.formatMessage({
                          id: 'tag',
                        })
                      )}
                    </div>
                    {showBannerChartTag && (
                      <InfoPanel onDismiss={handleCloseBannerChartTag}>
                        {intl.formatMessage(
                          {
                            id: 'top5TagsPorAcoes',
                          },
                          { tags: resources.tags, acoes: resources.acoes }
                        )}
                      </InfoPanel>
                    )}
                    <Grafico
                      height={320}
                      grafico={chartQuantidadeAcoesPorTag}
                      exibirTitulos={false}
                    />
                  </>
                )}
              </div>
            </Col>
            <Col md={6} className="px-2">
              <div
                style={{
                  backgroundColor: 'white',
                  padding: '12px',
                }}
              >
                {chartQuantidadeAcoesPorArea && (
                  <>
                    <div className="font-weight-bolder">
                      {capitalizeFirstLetter(resources.area)}
                    </div>
                    {showBannerChartArea && (
                      <InfoPanel onDismiss={handleCloseBannerChartArea}>
                        {intl.formatMessage(
                          {
                            id: 'top5AreasPorAcoes',
                          },
                          { areas: resources.areas, acoes: resources.acoes }
                        )}
                      </InfoPanel>
                    )}
                    <Grafico
                      height={320}
                      grafico={chartQuantidadeAcoesPorArea}
                      exibirTitulos={false}
                    />
                  </>
                )}
              </div>
            </Col>
          </Row>
          {isDrawerMounted && (
            <FiltroDrawerNew
              modelValue={selectedFilter.valor}
              filtroId={filtroId}
              usarFiltroSalvo={true}
              searchComponent={searchComponent}
              searchSchema={searchSchema}
              onSearch={refresh}
              showModal={false}
              url={url}
              selectedFilter={selectedFilter}
              tipoItem={1}
              tipoLayout="drawer"
              isOpen={showFilterDrawer}
              handleClose={handleCloseDrawer}
              enableSearch={true}
            />
          )}
        </CardBody>
      </Card>
    </LoadingContainer>
  );
};

export default GraficosAcoes;
